var _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShieldDonkey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shield_donkey_svg__filter0_f_9560_132008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 56c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16z",
    fill: "#D6D6D6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shield_donkey_svg__clip0_9560_132008)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.393,
    cy: 66.719,
    rx: 21.429,
    ry: 1.406,
    fill: "#fff",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.174 42.532c.055-3.08-.23-5.874-.798-6.557 0 0 1.48 1.37 1.595 1.599.115.229.458-2.282.055-3.08 0 0 1.654.514 1.938 1.027 0 0 .23-2.108-.572-2.795 0 0 1.37.284 1.54-.742.17-1.026-.873-1.828-.743-1.938.553-.462 1.986.426 1.343-2.436 0 0 1.334 1.232 1.381-.789.012-.458.012-3.849 1.382-6.415 0 0 .513 2.626.97 2.74.459.114.834-2.64 1.003-2.64.17 0-.264 1.843.308 1.898.573.055 1.717-1.8 1.717-1.8s-.406 2.198-.004 2.313c.4.114 1.153-1.413 1.437-1.129.285.284-.351 1.93-.24 2.554.118.628-12.312 18.19-12.312 18.19z",
    fill: "#304449"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.646 55.282c-.656 0-1.343-.25-1.907-.715l.312-.343c.663.544 1.504.738 2.199.509.757-.253 1.274-.975 1.492-2.088.098-.506.138-1.307.185-2.235.162-3.22.403-8.088 3.403-10.057 1.555-1.023 3.849-1.354 6.608-.269l-.434.387c-2.491-.766-4.477-.679-5.902.257-2.803 1.843-3.04 6.576-3.197 9.706-.048.944-.087 1.757-.194 2.294-.315 1.622-1.156 2.218-1.804 2.435a2.48 2.48 0 01-.761.119zM54.317 66.599h2.336s-3.536-8.783.675-16.421l-2.956-.857s-2.041 8.665-1.938 9.41c.102.739 1.883 7.868 1.883 7.868z",
    fill: "#54676D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.684 64.025l.636 2.574h2.337s-.395-.983-.762-2.574h-2.21z",
    fill: "#374A4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.27 66.824h1.997s-1.855-4.406-1.567-5.503c.292-1.101 4.295-4.56 3.96-8.128-.336-3.564-1.268-11.427-3.478-11.06-2.207.367-6.344 3.793-4.153 10.117.525 1.52 2.42 5.451 2.27 5.925-.15.474-1.777 2.254-1.773 2.412.012.158 2.744 6.237 2.744 6.237z",
    fill: "#54676D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.01 64.025a856.39 856.39 0 001.25 2.802h1.998s-.584-1.389-1.046-2.802H34.01z",
    fill: "#374A4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.234 52.514c2.89 3.348 14.598 10.417 24.636 3.877 7.14-4.65 5.929-18.857 5.929-18.857s1.14-5.625 2.206-6.537c1.066-.912-5.779-7.602-6.462-2.964-.682 4.638-3.497 15.892-13.531 15.205-1.753-.118-6.663-2.416-9.505-3.268-2.286-.687-7.773 7.334-3.273 12.544z",
    fill: "#7C8E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.557 28.384c-.012.016-.02.032-.032.044-4.113 3.525.597 19.705-8.135 25.393-9.928 6.466-21.482-.375-24.529-3.762.273.853.71 1.686 1.378 2.452 2.89 3.347 14.597 10.417 24.635 3.876 7.141-4.65 5.93-18.857 5.93-18.857s1.14-5.625 2.206-6.537c.398-.343-.344-1.527-1.453-2.609z",
    fill: "#60757C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.219 27.346c-.857 3.486-.328 11.183 3.486 15.723l.394-10.923-3.88-4.8z",
    fill: "#54676D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.879 66.823h1.997s-1.654-4.788-1.31-5.988c.343-1.196 4.504-4.962 4.334-8.838-.17-3.876-.742-12.43-2.965-12.031-2.222.398-6.517 4.125-4.618 11.005.458 1.654 2.167 5.929 1.997 6.442-.17.513-1.883 2.451-1.883 2.621-.004.178 2.448 6.79 2.448 6.79z",
    fill: "#7C8E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.023 54.65c.41.493 1.67-.197 1.681-.715.052-1.985-2.344-2.838-2.281-5.502 0 .004-1.567 3.623.6 6.217z",
    fill: "#394B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.514 26.655c1.086-.063 4.445-5.818 2.593-10.594-1.05-2.72-4.689 8.198-2.593 10.594zM60.129 38.22c-.075 1.102-.375 3.905 2.317 4.296 3.082.446 3.611-2.965 3.193-4.334-.418-1.37-5.51.039-5.51.039z",
    fill: "#7C8E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.527 38.64c-.063.868-.312 3.078 1.93 3.386 2.566.352 3.004-2.337 2.657-3.418-.347-1.078-4.587.031-4.587.031z",
    fill: "#899EA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.238 37.305c-.063.869-.556 2.819 1.607 3.478 3.13.955 4.37-.798 4.022-1.875-.347-1.078-5.629-1.603-5.629-1.603z",
    fill: "#7C8E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.477 39.54c-1.618.015-6.454-.348-6.21-.553.246-.205 3.182-.26 3.182-.26s-2.36-1.043-2.072-1.177c.292-.13 2.633.608 2.633.608s-2.728-1.516-2.36-1.769c.367-.248 4.492 1.757 4.492 1.757l.335 1.393zM64.473 38.754c1.445-.032 5.779.288 5.566.497-.214.206-2.839.288-2.839.288s2.136 1.023 1.88 1.157c-.257.134-2.37-.584-2.37-.584s2.476 1.492 2.152 1.744c-.323.253-4.054-1.717-4.054-1.717l-.335-1.385z",
    fill: "#9AAF45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.954 38.868c-.036.837-.347 1.41.205 1.591.553.186.648-.043.648-.043.146-.269.13-1.18.13-1.18l-.983-.368zM63.108 39.09c-.051.64-.347 1.44.387 1.54.73.098.833-.143.833-.143.158-.288.051-1.271.051-1.271l-1.27-.126zM64.575 38.84c.055.861-.276 1.611.3 1.477.573-.134.632-.39.632-.39.118-.352.15-1.24.15-1.24l-1.082.154zM61.768 38.687c-.142.848.036 1.61-.402 1.448-.438-.161-.454-.418-.454-.418-.052-.355.02-1.232.02-1.232l.836.202z",
    fill: "#CEDADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.646 39.816c2.546-.04 4.713.264 3.915-3.956-.797-4.22-4.18-11.253-5.17-11.479-.987-.228-7.682-2.005-6.806 4.982.194 1.52 5.191 10.496 8.06 10.453z",
    fill: "#7C8E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.939 36.196c.027-.667.655-1.014 1.267-.79.64.238 1.12 1.141 1.875 1.153.462.008.935-1.05 1.283-1.547.623-.888 2.072 1.018 1.283-1.48-1.295-4.094-2.902-7.488-3.719-8.092-1.283-.956-7.5-2.862-6.94 3.323.139 1.524 4.82 10.303 4.95 7.433z",
    fill: "#96ACB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.663 29.88c.048-.592 1.216-2.731 3.423-2.597 2.202.13 3.62.66 4.077 1.974.462 1.314.166 4.606-1.646 4.803-2.356.253-5.988-2.538-5.854-4.18z",
    fill: "#889CA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.088 27.082c-1.027.114-5.18-5.44-4.177-10.453.569-2.85 5.771 7.753 4.177 10.453z",
    fill: "#96ACB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.64 29.746l.217-.016c-1.445-1.867-2.463.194-2.463.194l.446-.036c.351-.418.99-.872 1.8-.142zM63.591 29.434l.218-.015c-1.445-1.868-2.464.193-2.464.193l.446-.036c.352-.418.991-.872 1.8-.142z",
    fill: "#2F3F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.768 38.49c-.627-1.197-2.033-2.282-.931-2.515.832-.174 2.107 1.654 2.107 1.654l-1.176.86zM65.43 38.264c.121-1.31.911-2.688-.084-2.806-.651-.08-1.192 2.167-1.192 2.167l1.275.64z",
    fill: "#3C4F54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.859 64.072l1.014 2.752h1.998s-.458-1.323-.84-2.752h-2.172z",
    fill: "#374A4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.575 35.13c-1.88 4.346-5.325 8.535-11.566 8.108-1.753-.118-6.663-2.416-9.505-3.268-.221-.067-.47-.047-.738.035-2.262.549-6.3 4.256-4.45 10.97.084.296.206.683.352 1.113 12.703 2.483 24.703 2.913 25.907-16.958z",
    fill: "#889CA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.205 48.062c.371 3.331.221 4.492-1.413 7.93l1.192.726c.888-1.476 1.603-5.818.221-8.656z",
    fill: "#60757C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.376 66.599h1.938s-2.854-9.087 1.654-16.65l-3.99-.514s-3.261 4.327-1.998 8.44c.221.707 2.396 8.724 2.396 8.724z",
    fill: "#7C8E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.636 64.025c.414 1.445.746 2.574.746 2.574h1.938s-.379-.983-.703-2.574h-1.981z",
    fill: "#374A4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.785 49.025c.454 1.2.825 3.714-.047 7.172l1.07-1.456c.844-2.582.082-4.37-1.023-5.716z",
    fill: "#60757C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.494 25.601c-.446.427-3.979-3.777-3.102-7.5.402-1.709 3.84 6.549 3.102 7.5zM62.023 25.084c.777-.043 3.181-4.164 1.859-7.583-.754-1.946-3.36 5.866-1.86 7.583z",
    fill: "#4F646B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.011 43.238c-1.752-.118-6.663-2.416-9.505-3.268-.22-.067-.47-.047-.738.035-1.74.423-4.532 2.716-4.883 6.81 1.986.588 4.315.927 6.805.927 6.332 0 11.614-2.19 12.853-5.108-1.315.486-2.818.719-4.532.604z",
    fill: "url(#shield_donkey_svg__paint0_radial_9560_132008)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.084 56.525c1.591.343 5.527-6.363 3.111-10.508-2.416-4.145-6.521-3.024-7.204.395-.446 2.218 1.579 9.568 4.093 10.113z",
    fill: "#96ACB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.834 58.645c-.829.308-3.529-5.898-2.27-9.869 1.26-3.97 4.011-3.355 4.367-.043.232 2.151-.786 9.426-2.096 9.912z",
    fill: "#889CA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.588 35.036c-.241-1.378.28-4.678 1.626-4.713 1.35-.036 4.22 3.848 4.22 3.848l-5.846.865z",
    fill: "#96ACB2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shield_donkey_svg__clip1_9560_132008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.165 29.992L30.37 25.06c-.24-.08-.5-.08-.74 0l-14.795 4.932c-.478.16-.8.606-.8 1.11v17.933c0 8.828 14.855 15.58 15.487 15.863a1.168 1.168 0 00.956 0c.632-.283 15.487-7.035 15.487-15.863V31.102c0-.504-.322-.951-.8-1.11z",
    fill: "#77C6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.165 29.992L30.37 25.06a1.167 1.167 0 00-.416-.056v39.994L30 65c.163 0 .326-.034.478-.102.632-.283 15.487-7.035 15.487-15.863V31.102c0-.504-.322-.951-.8-1.11z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.323 34.54l-9.953-3.317c-.24-.08-.5-.08-.74 0l-9.953 3.318c-.477.159-.8.606-.8 1.11v12.063c0 2.676 1.838 5.363 5.46 7.986a32.515 32.515 0 005.185 3.035 1.168 1.168 0 00.956 0 32.511 32.511 0 005.184-3.035c3.623-2.623 5.46-5.31 5.46-7.986V35.651c0-.504-.322-.951-.8-1.11z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.323 34.54l-9.953-3.317a1.165 1.165 0 00-.416-.056v27.667c.015.001.03.003.046.003.163 0 .326-.034.478-.102a32.513 32.513 0 005.184-3.035c3.623-2.623 5.46-5.31 5.46-7.986V35.651c0-.504-.322-.951-.8-1.11z",
    fill: "#DBF2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shield_donkey_svg__clip0_9560_132008"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 73 10)",
    d: "M0 0h60v60H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shield_donkey_svg__clip1_9560_132008"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 25)",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shield_donkey_svg__paint0_radial_9560_132008",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.39473 1.38158 -3.47623 -.99318 34.026 42.665)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#C5D5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96ACB2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shield_donkey_svg__filter0_f_9560_132008",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_9560_132008"
  })))));
}

export default __webpack_public_path__ + "./fonts/shield_donkey.e5b4ee4b693ccd960c93d9b595cb5d05.svg";
export { SvgShieldDonkey as ReactComponent };